import { render, staticRenderFns } from "./myAccountSet.vue?vue&type=template&id=04ecb0e0&scoped=true&"
import script from "./myAccountSet.vue?vue&type=script&lang=js&"
export * from "./myAccountSet.vue?vue&type=script&lang=js&"
import style0 from "./myAccountSet.vue?vue&type=style&index=0&id=04ecb0e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ecb0e0",
  null
  
)

export default component.exports